import { Box } from "@pingux/astro";
import GitHubRepos from "@components/GitHubRepos";

const SaasPrs: React.FC = () => {
  return (
    <Box
      sx={{
        padding: "2rem 2.5rem",
      }}
    >
      <GitHubRepos />
    </Box>
  );
};

export default SaasPrs;
